import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/pack")({
  component: () => <Outlet />,
});
